<template>
  <v-layout
    column
    class="wrapper px-4 py-7"
    :class="{ 'pa-8': $vuetify.breakpoint.smAndUp }"
    :style="{ backgroundImage: `url(${require('@/assets/BG.png')})` }"
  >
    <!-- BACK -->
    <div class="add-filler">
      <v-layout
        @click="$router.push({ name: routeNames.main.name })"
        align-center
        class="clickable toolbar-text"
      >
        <v-icon
          color="white"
          class="mr-1"
          :class="{ 'mr-2': $vuetify.breakpoint.smAndUp }"
          :size="$vuetify.breakpoint.xsOnly ? 23 : 30"
        >
          mdi-arrow-left
        </v-icon>
        <span>{{ $t("order.back_to_homepage") }}</span>
      </v-layout>
    </div>
    <v-spacer />
    <v-layout column justify-center class="flex-none" >
      <span class="main-text" :class="{ 'mx-3': $vuetify.breakpoint.xsOnly }">
          {{
            paymentAproved
              ? $t("order.success.thank_you")
              : $t("order.error.payment_error")
          }}
        </span>
    </v-layout>
    <!--success payment data-->
    <v-layout v-if="paymentAproved" wrap class="flex-none" justify-center ma-4>
      <v-flex xs12 sm12 md9 lg8>
        <v-layout wrap>
          <v-flex
            v-for="(displayedField, i) in displayedFields"
            :key="i"
            class="white--text font-weight-medium"
            my-3
            xs12
            sm6
          >
            <v-layout
              justify-center
              align-center
              class="full-height"
            >
              <span class="body-2 uppercase font-weight-medium">{{ displayedField.name }}</span>
              <v-divider vertical color="white" class="mx-3" />
              <span class="text-ellipsis">{{
                displayedField.value
              }}</span>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!--error payment-->
    <v-layout v-else column wrap ma-4>
      <span class="description-text ma-4" style="text-align: center;">{{$t("order.error.no_payment")}}</span>
      <v-divider color="white"/>
      <span class="description-text ma-4" style="text-align: center;">{{
        resultParams.nb_error
      }}</span>
    </v-layout>
    <v-spacer v-if="$vuetify.breakpoint.xsOnly" />
    <v-layout
      justify-center
      class="flex-none"
      :class="{ 'mx-2': $vuetify.breakpoint.xsOnly }"
    >
      <v-flex xs12 sm7 md4 lg3 xl2>
        <main-button
          v-if="paymentAproved"
          class="my-5"
          :text="$t('order.download_ticket')"
          @click="downloadTicket"
          :loading="loadingTicket"
          dark
        />
        <main-button
          v-else
          :text="$t('order.retry_payment')"
          @click="retryPayment()"
          :loading="loadingPost"
          class="my-10"
          dark
        />
      </v-flex>
    </v-layout>
    <v-spacer v-if="$vuetify.breakpoint.smAndUp" />
  </v-layout>
</template>

<script>
import routeNames from '@/router/routes'
import { mapState, mapGetters } from 'vuex'
import snakeCaseKeys from 'snakecase-keys'
import { PackageRequests } from '@/services/package.service'
import ServerDirections from '@/config/server-directions'
import vuetifyMixins from '@/mixins/Vuetify'
const packageService = new PackageRequests()
export default {
  data () {
    return {
      routeNames,
      loadingPost: false,
      loadingTicket: false,
      resultParams: this.$route.query,
      displayedFields: [
        { name: this.$t('fields.quantity'), value: this.$route.query.importe + ' ' + this.$route.query.nbMoneda },
        { name: this.$t('fields.date'), value: this.$route.query.fecha },
        { name: this.$t('fields.card_type'), value: this.$route.query.marca },
        { name: this.$t('fields.reference'), value: this.$route.query.referencia },
        { name: this.$t('fields.operation'), value: this.$route.query.operacion },
        { name: this.$t('fields.authorization'), value: this.$route.query.nuAut }
      ]
    }
  },
  mixins: [
    vuetifyMixins
  ],
  computed: {
    ...mapState(['state', 'cart', 'auth', 'guest']),
    ...mapGetters({
      total: 'cart/total'
    }),
    paymentAproved () {
      return this.resultParams.nbResponse === 'Aprobado'
    },
    orderId () {
      return this.resultParams.reference
        ? this.resultParams.reference
        : this.resultParams.referencia
          ? this.resultParams.referencia
          : null
    }
  },
  methods: {
    retryPayment () {
      this.loadingPost = true
      const body = {
        guestId: this.cart.selectedGuest,
        packages: this.cart.cartProducts.map((cartProduct) => {
          return {
            packageId: cartProduct.product.id,
            quantity: cartProduct.quantity
          }
        }),
        currencyId: this.cart.selectedCurrency.currency.id,
        amount: this.cart.selectedCurrency.exchangeRate ? (this.total / this.cart.selectedCurrency.exchangeRate) : this.total
      }
      packageService
        .postOrder(snakeCaseKeys(body, { deep: true }))
        .then((url) => {
          location.replace(url)
        })
        .catch(() => {
          this.loadingPost = false
        })
    },
    downloadTicket () {
      const route = ServerDirections.ORDERS_ID_TICKET.replace(
        '{id}',
        this.orderId
      )
      window.open(`${route}?download=true&x-api-key=${this.auth.authToken}`)
      this.$store.commit('state/setMessage', {
        text: this.$t('order.download_ticket_success'),
        color: 'success'
      })
      this.loadingTicket = true
      setTimeout(() => {
        this.loadingTicket = false
      }, 1000)
    }
  },
  created () {
    if (this.paymentAproved) {
      this.$store.commit('cart/resetCart')
    } else {
      this.$store.commit('cart/recoverCart')
      this.$store.dispatch('guests/get', { id: this.cart.selectedGuest, save: true })
    }
  },
  components: {
    MainButton: () => import('@/components/app-components/MainButton.vue')
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  min-height: 400px;
  height: 83%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right bottom;
  @media (max-width: 600px) {
    height: 88%;
  }
  & span,
  .layout {
    z-index: 1;
  }
}
.add-filler::before {
  content: "";
  background-color: var(--v-primary-base);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 76.8%;
  min-height: 370px;
}
.toolbar-text {
  color: white;
  font-weight: 1000;
  font-size: 13px;
  text-transform: uppercase;
  @media (min-width: 601px) {
    font-size: 18px;
  }
}
.main-text {
  font-size: 30px;
  font-weight: 1000;
  text-align: center;
  color: white;
  line-height: normal;
  @media (min-width: 601px) {
    font-size: 50px;
  }
  @media (min-width: 961px) {
    font-size: 74px;
  }
}
.description-text {
  font-size: 15px;
  font-weight: 1000;
  text-align: center;
  color: white;
  line-height: normal;
  @media (min-width: 601px) {
    font-size: 20px;
  }
  @media (min-width: 961px) {
    font-size: 25px;
  }
}
</style>
